import { useTranslation } from 'react-i18next'

const LivingRoom4 = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="livingroom4-title"
      {...props}
    >
      <title id="livingroom4-title">{t('antagonists:noOpinionsDad:components:background')}</title>
      <defs>
        <clipPath id="livingroom4-a">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="livingroom4-b">
          <path
            style={{
              fill: '#d6c4c9',
            }}
            d="m1400.75 435.1-293.41.5.04-203.29 290.24.81 3.13 201.98z"
          />
        </clipPath>
        <clipPath id="livingroom4-c">
          <path
            style={{
              fill: '#008499',
            }}
            d="m330.95 334.08 2.03 91.18 20.43.91-1.33-91.61-21.13-.48z"
          />
        </clipPath>
        <clipPath id="livingroom4-d">
          <path
            style={{
              fill: '#f19eb0',
            }}
            d="m138.2 396.59 142.24-.66.96 29.23-143.96 4.21.76-32.78z"
          />
        </clipPath>
        <clipPath id="livingroom4-e">
          <path
            d="m152.61 200.2.33 119.86s11.21 2.36 19.42 2.36 16.04-2.59 16.04-2.59l-1.55-120.15-34.23.52Z"
            style={{
              fill: '#3fa25a',
            }}
          />
        </clipPath>
        <clipPath id="livingroom4-f">
          <path
            d="m278.26 222.43.36 101.81s12.24 2 21.19 2c8.96 0 17.51-2.2 17.51-2.2l-1.7-102.06-37.37.44Z"
            style={{
              fill: '#f2c900',
            }}
          />
        </clipPath>
        <clipPath id="livingroom4-g">
          <path
            d="m250.61 212.74.33 108.67s4.41 2.36 12.61 2.36 5.84-2.59 5.84-2.59l-1.55-108.96-17.23.52Z"
            style={{
              fill: '#8cbb15',
            }}
          />
        </clipPath>
        <clipPath id="livingroom4-h">
          <path
            d="m190.58 186.86-4.64 133.68s2.05 1.39 10.25 1.69c8.2.3 16.13-1.99 16.13-1.99l3.42-134.01-25.16.63Z"
            style={{
              fill: '#3b9bd2',
            }}
          />
        </clipPath>
        <clipPath id="livingroom4-i">
          <path
            d="m214.84 189 .41 133.76s5.21 2.36 14.91 2.36 18.96-2.59 18.96-2.59l-1.86-134.05-32.42.52Z"
            style={{
              fill: '#e96132',
            }}
          />
        </clipPath>
        <clipPath id="livingroom4-j">
          <path
            style={{
              fill: '#54535e',
            }}
            d="M389.58 341.1h11.96l1.14 81.76-11.39.57-1.71-82.33z"
          />
        </clipPath>
        <clipPath id="livingroom4-k">
          <path
            d="M1551.03 620.56c6.56 5.06.16 40.48-12.44 63.64-10.37 19.06-17.84 27.21-31.03 27.61-12.65.39-94.64-11.04-98.07-17.62-3.52-6.76.66-36.8 9.96-60.74 9.29-23.94 28.4-31.28 42.01-33.1 13.61-1.82 75.95 9.71 89.56 20.22Z"
            style={{
              fill: '#d29bc2',
            }}
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: 'url(#livingroom4-a)',
        }}
      >
        <path
          style={{
            fill: '#fdf9ee',
          }}
          d="M-121.67-137.97h2137.5v1191.53h-2137.5z"
        />
        <path
          style={{
            fill: '#f1e3db',
          }}
          d="M842.95 786.55 837.02 107l-324.43.44.8 681.29 329.56-2.18z"
        />
        <path
          style={{
            fill: '#e7ca7d',
          }}
          d="m816.66 128.43-282.3 1.02-1.74 682.86 289.14-2.06-5.1-681.82z"
        />
        <path
          style={{
            fill: '#eaeaea',
          }}
          d="m794.52 449.55-.27 68.07-23.07-.48 1.08-68.54 22.26.95z"
        />
        <path
          style={{
            fill: '#2a5151',
          }}
          d="m787.78 460.74-54.15.91-.53 7.05 54.68 4.97v-12.93z"
        />
        <path
          d="M791.66 495.23c0 4.11-2.15 8.38-8.32 8.83-6.17.44-10.09-3.65-9.89-8.93.19-4.9 3.53-8.43 9.59-8.37 5.68.06 8.62 4.14 8.62 8.47Z"
          style={{
            fill: '#3aab90',
          }}
        />
        <path
          style={{
            fill: '#00658b',
          }}
          d="m780.48 488.65 7.58 10.39-3.54 2.87-7.56-10.69 3.52-2.57z"
        />
        <path
          d="m1096.72 222.69 1.08 222.96 314.08-.56-3.29-220.94-.03-2.16-311.83.7Z"
          style={{
            fill: '#bba063',
          }}
        />
        <path
          style={{
            fill: '#d6c4c9',
          }}
          d="m1400.75 435.1-293.41.5.04-203.29 290.24.81 3.13 201.98z"
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-b)',
          }}
        >
          <path
            style={{
              fill: '#f7c2b4',
            }}
            d="m1080.32 464.14 332.38 2.53 2.27-257.36-332.38-2.53-2.27 257.36z"
          />
          <path
            d="M1171.06 347.53c21.98 0 35.72-4.47 45.75-9.95 9.96-5.44 16.86-10.9 28.96-17.03 12.9-6.52 43.37-7.94 67.99-7.61 38.72.52 295.05 1.28 295.05 1.28l-13.29 91.16-641.81 38.3-2.44-96.16h219.79Z"
            style={{
              fill: 'none',
            }}
          />
          <path
            d="M1782.51 450.42s-645.88-292.59-662.7-299.9c-16.82-7.29-40.04-18.78-47.69-4.32-7.89 14.91 6.71 22.26 17.06 30.76 4.82 3.96 13.18 11.19 6.91 23.19-6.72 12.86-20.49 11.08-40.36.09-21.59-11.93-904.36-423.87-904.36-423.87L120.03-127l1542.06 726.78 120.42-149.36Z"
            style={{
              fill: '#ee7f00',
            }}
          />
          <path
            d="M1770.98 566.3s-368.08-177.31-404.16-194.61c-36.08-17.3-62.97-33.25-72.27-19.52-6.69 9.88 1.39 15.05 21.58 32.19 8.13 6.9 11.54 15.53 7.68 22.63-5.72 10.52-17.11 11.3-38.73 1.06-41.52-19.66-648.06-302.58-648.06-302.58L513.13 361.41 1629.6 911.78l141.38-345.48Z"
            style={{
              fill: '#f29e97',
            }}
          />
        </g>
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#d3dde2',
          }}
          d="M-233.98 753.54h2250.39v813.52H-233.98z"
        />
        <path
          d="M1691.19 329.01c-10.98-1.54-17.26 3.44-18.88 10.54-1.69 7.44.69 16.6 10.99 19.09 10.47 2.53 20.02-4.24 20.66-12.1.6-7.51-1.8-15.98-12.77-17.52Z"
          style={{
            fill: '#6b5738',
          }}
        />
        <path
          d="M1693.13 353.66c-16.35-2.29-25.71 5.12-28.12 15.69-2.51 11.08 1.03 24.72 16.37 28.43 15.6 3.77 29.82-6.31 30.77-18.03.89-11.18-2.67-23.8-19.02-26.1Z"
          style={{
            fill: '#6b5738',
          }}
        />
        <path
          style={{
            fill: '#6b5738',
          }}
          d="m1680.92 296.96 8.4 563.09 14.47-5.78-10.12-552.75-12.75-4.56z"
        />
        <path
          d="M1642.62 865.64s.52-13.02 3.11-18.45c3.32-6.96 11.69-9.81 25.86-10.94 14.64-1.17 37.61.02 46.31.02 13.26 0 24.54 1.98 26.52 11.48 1.84 8.84 2.77 16.62 2.77 16.62l-104.57 1.27Z"
          style={{
            fill: '#6b5738',
          }}
        />
        <path
          style={{
            fill: '#ffd500',
          }}
          d="m1566.16 211.97-1.23 95.71 240.76-1.12-1.46-96.29-238.07 1.7z"
        />
        <path
          style={{
            fill: '#4b6c52',
          }}
          d="m1306.4 776.63-4.67 93.79-12.68-.77-8.35-90.55 25.7-2.47zm229.86-2.91 5.99 98.23 13.9-.51 5.81-95.26-25.7-2.46z"
        />
        <path
          d="M1590.41 672.81c-.52-22.7-16.04-38.29-29.98-59.3-8.47-12.78 1.76-55.33 3.52-72.84 3.43-34.35 15.38-65.84-8.39-94.45-21.26-25.59-82.23-22.66-140.37-21.75-58.13-.91-100.91-9.24-123.45 25.53-16.58 25.58-13.32 45.3-6.05 97.98 3.34 24.21 16.03 54.12 7.79 65.53-16.42 22.76-34.33 36.6-34.85 59.3-.52 22.7 5.67 105.61 6.19 118.44.52 12.83 9.61 12.76 24.01 14.96 38.31 5.85 228.77 4.62 271.37 0 14.5-1.57 21.87-6.03 22.39-18.86.52-12.83 8.33-91.83 7.81-114.54Z"
          style={{
            fill: '#35aa8e',
          }}
        />
        <path
          d="M1577.98 680.46c-4.99-12.47-26.41-17.1-43.22-21.58-15.25-4.06-39.43-4-101.36-3.94-61.92.06-103.71.17-119.04 3.94-22.5 5.54-38.37 9.49-43.22 21.58-2.75 6.86 0 18.82 0 33.51 0 14.69 1.08 29.02 12.53 30.86 11.46 1.84 159.1 3.31 159.58 3.29 27.6-.92 109.82-1.46 121.28-3.29 11.46-1.84 13.44-16.16 13.44-30.86 0-14.69 2.75-26.65 0-33.51Z"
          style={{
            fill: '#00a183',
          }}
        />
        <path
          style={{
            fill: '#008499',
          }}
          d="m330.95 334.08 2.03 91.18 20.43.91-1.33-91.61-21.13-.48z"
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-c)',
          }}
        >
          <path
            style={{
              fill: '#bd2e86',
            }}
            d="m325.15 403.48 33.22.54-2.01-9.66-34.57 1.35 3.36 7.77z"
          />
          <path
            style={{
              fill: '#8cabbc',
            }}
            d="m324.3 403.26 32.4-.27.47 29.18-36.73 1.08 3.86-29.99z"
          />
        </g>
        <path
          style={{
            fill: '#f19eb0',
          }}
          d="m138.2 396.59 142.24-.66.96 29.23-143.96 4.21.76-32.78z"
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-d)',
          }}
        >
          <path
            style={{
              fill: '#eb6a36',
            }}
            d="m180.46 433.1-1.78-42.42 45.07-.02L222 432.2l-41.54.9z"
          />
        </g>
        <path
          style={{
            fill: '#ee7d00',
          }}
          d="m357.07 343.24 1.39 80.08 30.96.31-2.38-79.93-29.97-.46z"
        />
        <path
          style={{
            fill: '#645e18',
          }}
          d="m363.92 370.06 1.14 45.01 17.57.63-.24-45.35-18.47-.29z"
        />
        <path
          style={{
            fill: '#0a9791',
          }}
          d="m136.07 367.14 149.19-2.32.7 33.25H135.43l.64-30.93z"
        />
        <path
          style={{
            fill: '#00814c',
          }}
          d="m209.58 392.17 56.42-.97-.63-20.13-56.3.66.51 20.44z"
        />
        <path
          d="m152.61 200.2.33 119.86s11.21 2.36 19.42 2.36 16.04-2.59 16.04-2.59l-1.55-120.15-34.23.52Z"
          style={{
            fill: '#3fa25a',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-e)',
          }}
        >
          <path
            style={{
              fill: '#df007a',
            }}
            d="m147.8 228.22 41.63-1.04 1.55 66.95-43.69 1.03.51-66.94z"
          />
        </g>
        <path
          d="m278.26 222.43.36 101.81s12.24 2 21.19 2c8.96 0 17.51-2.2 17.51-2.2l-1.7-102.06-37.37.44Z"
          style={{
            fill: '#f2c900',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-f)',
          }}
        >
          <path
            style={{
              fill: '#ef8227',
            }}
            d="m272.38 274.3 45.44-.88 1.69 56.86-47.7.88.57-56.86z"
          />
        </g>
        <path
          d="m250.61 212.74.33 108.67s4.41 2.36 12.61 2.36 5.84-2.59 5.84-2.59l-1.55-108.96-17.23.52Z"
          style={{
            fill: '#8cbb15',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-g)',
          }}
        >
          <path
            style={{
              fill: '#497125',
            }}
            d="m249.42 209.8 33.12-1.04 1.56 69.78-35.2 1.04.52-69.78z"
          />
        </g>
        <path
          d="m190.58 186.86-4.64 133.68s2.05 1.39 10.25 1.69c8.2.3 16.13-1.99 16.13-1.99l3.42-134.01-25.16.63Z"
          style={{
            fill: '#3b9bd2',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-h)',
          }}
        >
          <path
            style={{
              fill: '#007ca6',
            }}
            d="m185.35 203.7 33.91.59-.52 36.53-35.21-1.97 1.82-35.15z"
          />
        </g>
        <path
          d="m214.84 189 .41 133.76s5.21 2.36 14.91 2.36 18.96-2.59 18.96-2.59l-1.86-134.05-32.42.52Z"
          style={{
            fill: '#e96132',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-i)',
          }}
        >
          <path
            style={{
              fill: '#e53446',
            }}
            d="m208.91 161.19 39.15-1.04 1.84 104.93-41.59 1.04.6-104.93z"
          />
          <path
            style={{
              fill: '#7b408e',
            }}
            d="m213.45 99.96 39.14-1.04 1.85 104.93-41.59 1.04.6-104.93z"
          />
        </g>
        <path
          style={{
            fill: '#54535e',
          }}
          d="M389.58 341.1h11.96l1.14 81.76-11.39.57-1.71-82.33z"
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-j)',
          }}
        >
          <path
            style={{
              fill: '#62b5ad',
            }}
            d="m387.47 354.5 16.8-.24.96 40.55-18 .24.24-40.55z"
          />
        </g>
        <path
          d="m454.49 331.96.15-11.31-15.34-.02 1.47-141.12-13.58-1.13-.9 142.23-280.94-.45 1.46-140.64-13.58-1.13-.9 141.75-13.59-.02-1.34 10.17 14.86.07-.59 92.31-17.78.05-.26 10.45 17.98-.27-.47 73.42 12.27-.96.75-72.46 281.4.1-.47 73.32 12.27-.96.75-72.35h11.57l.09-11.31-11.55.04.94-89.84 15.3.08Zm-28.84 89.8-281.36.85.96-92.21 280.97 1.41-.57 89.95Z"
          style={{
            fill: '#cd8d5b',
          }}
        />
        <path
          d="M1551.03 620.56c6.56 5.06.16 40.48-12.44 63.64-10.37 19.06-17.84 27.21-31.03 27.61-12.65.39-94.64-11.04-98.07-17.62-3.52-6.76.66-36.8 9.96-60.74 9.29-23.94 28.4-31.28 42.01-33.1 13.61-1.82 75.95 9.71 89.56 20.22Z"
          style={{
            fill: '#d29bc2',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom4-k)',
          }}
        >
          <path
            d="M1391.81 742.9s28.96-.41 54.23-9.86c24.53-9.18 153.91-77.05 153.91-77.05l-1.08-8.38s-141.25 73.65-156.25 78.31c-14.53 4.51-45.37 7.51-45.37 7.51l-5.43 9.48Zm.94 19.73s29.65.43 55.56-8.71c25.18-8.88 158.32-76.22 158.32-76.22l-1.17-8.79s-145.29 73.04-160.68 77.47c-14.9 4.29-46.48 6.52-46.48 6.52l-5.55 9.73Z"
            style={{
              fill: '#bb5396',
            }}
          />
          <path
            d="M1393 724.28s28.47-1.16 53.29-10.93c24.07-9.48 150.67-78.01 150.67-78.01l-1.04-8.03s-138.27 74.39-152.99 79.27c-14.27 4.73-44.59 8.42-44.59 8.42l-5.34 9.28Zm4.06-22.51s28.11-2.04 52.55-12.21c23.68-9.85 147.87-79.4 147.87-79.4l-1.02-7.66s-135.7 75.53-150.19 80.68c-14.06 4.99-43.98 9.51-43.98 9.51l-5.23 9.08Zm1.58-22.17s27.54-2.87 51.45-13.36c23.14-10.16 144.12-80.28 144.12-80.28l-.97-7.27s-132.26 76.2-146.42 81.57-43.06 10.5-43.06 10.5l-5.12 8.84Zm2.35-21.38s27.06-3.63 50.51-14.43c22.67-10.44 140.88-81.12 140.88-81.12l-.93-6.92s-129.27 76.84-143.16 82.43c-13.49 5.42-42.28 11.42-42.28 11.42l-5.01 8.63Zm13.43-24.99s27.38-4.56 50.98-15.89c22.81-10.95 141.4-83.66 141.4-83.66l-1.03-6.64s-129.71 79.08-143.7 85.01c-13.59 5.76-42.69 12.66-42.69 12.66l-4.95 8.52Z"
            style={{
              fill: '#bb5396',
            }}
          />
        </g>
        <path
          d="m1231.36 646.34-242.01-.62-.11 19.03h16.72l.06 207.05H1028l2.22-48.52 157.49.25 1.47 49.68 21.7.84 4.16-209.19h16.93l-.6-18.53Zm-200.83 166.05 2.97-132.35 152.06-.49 1.95 133.2-156.97-.35Z"
          style={{
            fill: '#e0a758',
          }}
        />
      </g>
    </svg>
  )
}

export default LivingRoom4
